import React ,{useState,useEffect,useRef} from "react";
import { ConfigProvider } from "antd";
import { lightTheme } from "./theme";
import NavigationManager from "./NavigationManager";
import Loader from "./Components/Loader";

const App = () => {
  const [isTabAlreadyOpen, setIsTabAlreadyOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);


    useEffect(() => {
      const tabId = Math.random().toString(36).substring(7);
      const channel = new BroadcastChannel("tab_guard");
      const openedAt = Date.now();
  
      const handleMessage = (event) => {
        if (event.data.type === "PING") {
          channel.postMessage({
            type: "PONG",
            tabId,
            openedAt,
          });
          setIsTabAlreadyOpen(false);
          setIsLoading(false);
        }
  
        if (event.data.type === "PONG" && event.data.openedAt < openedAt) {
          setIsTabAlreadyOpen(true);
          setIsLoading(false);
        }
      };
  
      channel.addEventListener("message", handleMessage);
  
      channel.postMessage({
        type: "PING",
        tabId,
      });
  
      // Fallback timeout in case no response is received
      const timeoutId = setTimeout(() => {
        setIsLoading(false);
      }, 2000);
  
      return () => {
        clearTimeout(timeoutId);
        channel.removeEventListener("message", handleMessage);
        channel.close();
      };
    }, []);

    if (isLoading) {
      return <Loader />;
    }

    if (isTabAlreadyOpen) {
      return (
        <div className="duplicate-wrapper">
          <div className="duplicate">
            <h1>
              { " " }
              <i class="fa-solid fa-triangle-exclamation"></i> Duplicate Tab
              Detected
            </h1>
            <p>This application is already running in another tab.</p>
            <p>
              Please return to the original tab or close that tab and refresh this
              page.
            </p>
          </div>
        </div>
      );
    }

    
  return (
    <>
      {/* <Helmet> */}
        {/* <title>{title}</title> */}
        {/* <link rel="icon" type="image/png" href={faviconUrl} /> */}
      {/* </Helmet> */}
      <ConfigProvider theme={lightTheme}>
        <NavigationManager />
      </ConfigProvider>
    </>
  );
};

export default App;
